import { useEffect, useState } from 'react';

/* Hook de media query para decidir en JS lo que el CSS no puede (ticks y leyenda
   de Recharts, popover frente a hoja inferior). Mismos niveles que el CSS:
   compacto hasta 767px y teléfono hasta 480px. Seguro sin window. */
export function useMediaQuery(query) {
  const read = () => (typeof window !== 'undefined' && window.matchMedia ? window.matchMedia(query).matches : false);
  const [matches, setMatches] = useState(read);
  useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return undefined;
    const mql = window.matchMedia(query);
    const onChange = (e) => setMatches(e.matches);
    setMatches(mql.matches);
    if (mql.addEventListener) mql.addEventListener('change', onChange);
    else mql.addListener(onChange);
    return () => {
      if (mql.removeEventListener) mql.removeEventListener('change', onChange);
      else mql.removeListener(onChange);
    };
  }, [query]);
  return matches;
}

export const useIsMobile = () => useMediaQuery('(max-width: 767px)');
export const useIsPhone = () => useMediaQuery('(max-width: 480px)');
export const useHasHover = () => useMediaQuery('(hover: hover)');

export default useMediaQuery;
